import React from 'react';
import HierarchicalGroupSelector from './HierarchicalGroupSelector';

const HierarchicalGroupAvailabilityRequirementSelector = ({
  groupsTree,
  parentGroupId,
  selectedAvailabilityRequirements,
  label,
  onChange
}) => (
  <HierarchicalGroupSelector
    groupsTree={groupsTree}
    parentGroupId={parentGroupId}
    label={label}
    selected={selectedAvailabilityRequirements}
    onChange={onChange}
    attribute={'availability_requirements'}
  />
);

export default HierarchicalGroupAvailabilityRequirementSelector;
